
export default {

  reportId: null,
  versionId: null,
  created: null,
  updated: null,
  version: null,
  sender: {},

  vesselDetail: {},

  reportItems: [],

  reportDetail: {},

  workflowStatus: {},

  histories: [],

  groupedHistories: {
    today: [],
    yesterday: [],
    more: []
  },

};
